export default __webpack_public_path__ + "static/media/nikolay.f67af23a.jpg";